import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ENV } from 'src/app/models/Env';
import { WebAnalyticsUTagData } from './WebAnalyticsUTagData';
import { BehaviorSubject } from 'rxjs';
import { CancelRefundService } from '../services/rest-api/cancel-refund.service';
import { RefundReviewRq } from '../models/RefundReviewRq';
import { WINDOW } from '../models/WindowProvider';

@Injectable()
export class AnalyticsHandlerService {
  utagData: WebAnalyticsUTagData = new WebAnalyticsUTagData();
  refundReviewRq$: BehaviorSubject<RefundReviewRq> =
    new BehaviorSubject<RefundReviewRq>(undefined);

  constructor(
    @Inject(ENV) public env: string,
    @Inject(WINDOW) private window: Window,
    private cancelRefundService: CancelRefundService
  ) {}

  getTealiumConfigs(): any {
    return {
      account: environment.tealium.account,
      profile: environment.tealium.profile,
      environment: this.getUtagEnv(),
    };
  }

  getUtagEnv(): string {
    if (this.env === 'stage') {
      return 'qa';
    }
    if (this.env === 'local') {
      return 'dev';
    }
    return this.env;
  }

  setRefundReviewRq(refundReviewRq: RefundReviewRq): void {
    this.refundReviewRq$.next(refundReviewRq);
  }

  get refundReviewRq(): RefundReviewRq {
    return this.refundReviewRq$.getValue();
  }

  get getUtagData(): WebAnalyticsUTagData {
    return this.utagData;
  }

  getSiteLanguage() {
    const locale = sessionStorage.getItem('locale') || 'en_US';
    return locale.split('_')[0].toUpperCase();
  }

  populateStatusLookupUtagData() {
    this.utagData.channel = 'View Res';
    this.setLoginStatus();
    this.utagData.page_name = 'Self Service Refund- 24 Hr';
    this.utagData.server = 'ngrefund-web-ui';
    const locale: string = localStorage.getItem('locale');
    const locales = locale.split('_');
    this.utagData.site_country = locales[1];
    this.utagData.site_indicator = 'AAcom';
    this.utagData.site_language = locales[0].toUpperCase();
    this.setTealiumEnvironment();
    this.utagData.tealium_profile = 'main';
    const d = new Date();
    this.utagData.time_stamp =
      this.checkZero(d.getMonth() + 1) +
      '/' +
      this.checkZero(d.getDate()) +
      '/' +
      this.checkZero(d.getFullYear()) +
      ' ' +
      this.checkZero(d.getHours()) +
      ':' +
      this.checkZero(d.getMinutes()) +
      ':' +
      this.checkZero(d.getSeconds());
    this.setLoyaltyMemberInfo();
  }

  setTealiumEnvironment() {
    this.cancelRefundService.environment().subscribe(
      (val) => {
        console.log('GET call successful, environment returned ', val);
        this.utagData.tealium_environment = val;
      },
      (response) => {
        console.log('GET call for environment resulted in error');
        this.handleError();
      },
      () => {
        console.log('The GET observable for environment is now completed.');
      }
    );
  }

  setLoginStatus() {
    this.cancelRefundService.loginStatus(this.getHostname()).subscribe(
      (val) => {
        console.log('GET call successful, loginStatus returned ', val);
        if ('0' === val.status) {
          this.utagData.login_status = 'Logged_out';
        } else if ('1' === val.status) {
          this.utagData.login_status = 'Soft_Login';
        } else if ('2' === val.status) {
          this.utagData.login_status = 'Logged_in';
        } else {
          this.utagData.login_status = 'Logged_out';
        }
      },
      (response) => {
        console.log('GET call for loginStatus resulted in error');
        this.handleError();
      },
      () => {
        console.log('The GET observable for loginStatus is now completed.');
      }
    );
  }

  setLoyaltyMemberInfo() {
    this.cancelRefundService.loyaltyMemberInfo(this.getHostname()).subscribe(
      (val) => {
        console.log('GET call successful, loginStatus returned ', val);
        this.utagData.loyalty_balance = val.awardMiles.value.replace(',', '');
        this.utagData.loyalty_id = val.aadvantageNumber;
        this.utagData.loyalty_tier = val.tierLevel;
      },
      (response) => {
        console.log('GET call for loginStatus resulted in error');
        this.utagData.loyalty_balance = '';
        this.utagData.loyalty_id = '';
        this.utagData.loyalty_tier = '';
      },
      () => {
        console.log('The GET observable for loginStatus is now completed.');
      }
    );
  }

  checkZero(data) {
    data = data + '';
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  handleError() {
//    this.cancelRefundService.error().subscribe(
//      (val) => {
//        console.log('GET call successful, error endpoint returned ', val);
//        window.location.href = 'https://' + this.getHostname() + val;
//      },
//      (response) => {
        console.log('GET call for error endpoint in error');
//      },
//      () => {
//        console.log('The GET observable for error endpoint is now completed.');
//      }
//    );
  }

  getHostname(): string {
    return this.window.location.hostname;
  }
}
